import React, { useCallback, useEffect, useState } from 'react'

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalButton,
  SIZE,
  ROLE,
} from 'baseui/modal'
import { KIND as ButtonKind } from 'baseui/button'
import { styled } from 'baseui'
import { Select, Value } from 'baseui/select'
import { expandBorderStyles } from 'baseui/styles'
import DrawerSelect from 'components/Select/DrawerSelect'
import Checkbox, {
  LABEL_PLACEMENT,
  STYLE_TYPE,
} from 'components/CheckBox/CheckBox'
import MultipleCategorySelect from 'components/CategorySelect/MultipleCategorySelect'
import ColorsSelect from 'components/ColorsSelect/ColorsSelect'
import CountryOfOriginSelect from 'components/CountryOfOriginSelect/CountryOfOriginSelect'
import ShippingMethodSelect from 'components/ShippingMethodSelect/ShippingMethodSelect'

export interface ConfirmationOptions {
  catchOnCancel?: boolean
  variant: 'danger' | 'info'
  title: string
  description: string
  selectionOptions?: Array<selectionOptions> | undefined | null
}

interface ConfirmationDialogProps extends ConfirmationOptions {
  open: boolean
  onSubmit: (value) => any
  onClose: () => void
}

interface selectionOptions {
  id: number
  label: string
  color: string
}

export const ShippingMethodsSelectModal: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  variant,
  description,
  selectionOptions,
  onSubmit,
  onClose,
}) => {
  // console.log("We have selection options ->", selectionOptions);
  const [value, setValue] = useState(null)

  const [selectedShippingMethods, setSelectedShippingMethods] = useState([])

  // Reset modal value...
  useEffect(() => {
    setValue(null)
  }, [open])

  useEffect(() => {
    setValue(selectedShippingMethods)
  }, [selectedShippingMethods])

  const handleShippingMethodsOnChange = (newValue) => {
    //---
    setSelectedShippingMethods(newValue)
  }

  return (
    <Modal
      onClose={onClose}
      closeable
      isOpen={open}
      animate
      autoFocus
      size={SIZE.default}
      role={ROLE.dialog}
      overrides={{
        Root: {
          style: {
            zIndex: 100,
          },
        },
      }}
    >
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <p>{description}</p>

        <div>
          <ShippingMethodSelect
            onChange={(newValue) => handleShippingMethodsOnChange(newValue)}
            value={selectedShippingMethods}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        {variant === 'danger' && (
          <>
            <ModalButton
              kind={ButtonKind.tertiary}
              onClick={onClose}
              overrides={{
                BaseButton: {
                  style: ({ $theme }) => ({
                    color: $theme.colors.red400,
                  }),
                },
              }}
            >
              Cancel
            </ModalButton>
            <ModalButton
              onClick={(e) => onSubmit(value)}
              disabled={!value} // IF selection component and no value, then disabled...
              overrides={{
                BaseButton: {
                  style: ({ $theme }) => ({
                    backgroundColor: $theme.colors.red400,
                  }),
                },
              }}
            >
              Yes
            </ModalButton>
          </>
        )}

        {variant === 'info' && (
          <ModalButton
            disabled={selectedShippingMethods === null}
            onClick={(e) => onSubmit(value)}
          >
            OK
          </ModalButton>
        )}
      </ModalFooter>
    </Modal>
  )
}
